import React from 'react';

interface HeroSectionProps {
  greeting: string;
  subtitle?: string;
  animationsEnabled: boolean;
  onToggleAnimations: () => void;
}

export const HeroSection: React.FC<HeroSectionProps> = ({
  greeting,
  subtitle = 'What can I do for you?',
  animationsEnabled,
  onToggleAnimations,
}) => {
  return (
    <div className="text-center mb-6 pt-8 sm:pt-0">
      <div className="sm:absolute sm:top-4 sm:left-0 mb-4 sm:mb-0 flex justify-center sm:justify-start">
        <button
          id="toggle-background-animation"
          aria-label="Toggle background animation"
          aria-pressed={animationsEnabled}
          onClick={onToggleAnimations}
          className="group flex items-center gap-1.5 px-2 py-1 rounded-md transition-all duration-200 hover:bg-white/60 backdrop-blur-sm"
          title={animationsEnabled ? 'Turn off seasonal effects' : 'Turn on seasonal effects'}
        >
          <div
            className={`relative w-6 h-3.5 rounded-full transition-all duration-300 ${
              animationsEnabled ? 'bg-neutral-400' : 'bg-neutral-200'
            }`}
          >
            <div
              className={`absolute top-[2px] w-2.5 h-2.5 rounded-full shadow-sm transition-all duration-300 bg-white ${
                animationsEnabled ? 'translate-x-[12px]' : 'translate-x-[2px]'
              }`}
            />
          </div>
          <span className="text-[10px] text-neutral-400 group-hover:text-neutral-500 transition-colors">
            Effects
          </span>
        </button>
      </div>
      <h1 className="text-[26px] sm:text-[36px] font-serif font-normal text-neutral-900 mb-2 tracking-tight">
        {greeting}
      </h1>
      <p className="text-sm sm:text-base text-neutral-500">{subtitle}</p>
    </div>
  );
};
